/**
 * The opening date of a new game: 1 January 2026. DECISION (M12): a real date,
 * so the game's calendar is the field record's. A scenario can start another
 * day (`WorldOptions.startDate`), a past year to replay its weather among them.
 */
export const DEFAULT_START = { year: 2026, month: 1, day: 1 } as const;

/**
 * The side of an aquarium, km. DECISION (the design brief's scale answer, M1):
 * an aquarium is a real 100 km by 100 km area at real densities.
 */
export const AQUARIUM_SIDE_KM = 100;

/** One pound, kg, by definition: the international pound (review M194: written out in four places before). */
export const KG_PER_POUND = 0.45359237;
